export default __webpack_public_path__ + "static/media/add_icon.32e1bed6.svg";